import { msg } from '@lingui/core/macro';

export const SHARED_TABLE_EMPTY_STATE_FILTERED_TITLE = msg`No records found`;
export const SHARED_TABLE_EMPTY_STATE_FILTERED_DESCRIPTION = msg`Your search didn't match any results.`;
export const SHARED_TABLE_EMPTY_STATE_EMPTY_TITLE = msg`No records yet`;
export const SHARED_TABLE_EMPTY_STATE_EMPTY_DESCRIPTION = msg`Your content will appear here.`;
